// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckBox_root__Zd40H","labelClass":"CheckBox_labelClass__2IonH","text":"CheckBox_text__3IMqu","input":"CheckBox_input__3bmhW"};